import React, { useMemo } from 'react';

import { MultiSelect } from '@gogame/components';
import { withFormField } from '@gogame/form';

import { PLATFORM_ID } from './GGCampaignLinks';

const EMPTY_OPTIONS = [];

const normalizeValue = (value) => value?.map(({ [PLATFORM_ID]: id }) => id);

export const MultiChangeSelect = withFormField({})(
  ({
    value,
    options,
    loading,
    name,
    label,
    required,
    disabled,
    error,
    onMultiChange,
    helper,
    onBlur,
    onFocus,
  }) => {
    const newValue = useMemo(() => normalizeValue(value), [value]);

    // Fix to omit select extra render
    const selectValue = useMemo(() => newValue, [newValue?.toString()]);

    return (
      <MultiSelect
        name={name}
        data-cy={name}
        value={selectValue}
        onChange={onMultiChange}
        options={options || EMPTY_OPTIONS}
        loading={loading}
        label={label}
        required={required}
        error={error}
        disabled={disabled}
        helper={helper}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    );
  }
);

export default MultiChangeSelect;
